export default __webpack_public_path__ + "static/media/PattroOriginal.61510191.svg";